import { BlogSection } from "@/types/blog";

export const innereReife: BlogSection = {
  id: "innere-reife",
  title: "Innere Reife vor äußerer Rolle",
  content: `
    <p>Menschen spüren schnell, ob jemand aus Unsicherheit handelt oder aus innerer Klarheit.</p>

    <p>Wer eigene Emotionen regulieren kann, bleibt auch unter Druck ansprechbar. Diese Ruhe überträgt sich. In der Psychologie spricht man von <strong>Ko-Regulation</strong> zwischen Nervensystemen.</p>

    <p>Eine stabile Führungskraft wird so zum Anker.<br/>
    Nicht perfekt.<br/>
    Aber konsistent.</p>
  `
};
